import * as Yup from 'yup';
import { TFunction } from 'i18next';

export const createSchema = (t: TFunction) => Yup.object().shape({
  Email: Yup.string()
    .required(t('convidar.schemaEmailRequired'))
    .email(t('convidar.schemaEmailValid')),
});

export default createSchema;
